import { render } from "./SystemMessage.vue?vue&type=template&id=01e5b764&scoped=true"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"

import "./SystemMessage.vue?vue&type=style&index=0&id=01e5b764&scoped=true&lang=css"

import exportComponent from "/Users/rppig42/Code/dbkf/uworker-mobile/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.2.21_vue@3.2.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e5b764"]])

export default __exports__